import { parseTimeOfDay } from '../../time/zoned-time';
import type { WeeklySlot } from './dto';

/**
 * CHN-UC-3.CC-1: проверяет и нормализует сетку слотов — дубли схлопываются,
 * порядок: день недели, затем время. null — есть неверный слот.
 */
export function normalizeSlots(input: readonly WeeklySlot[]): WeeklySlot[] | null {
  const unique = new Map<string, WeeklySlot>();
  for (const slot of input) {
    if (!Number.isInteger(slot.weekday) || slot.weekday < 1 || slot.weekday > 7) return null;
    if (parseTimeOfDay(slot.time) === null) return null;
    unique.set(`${slot.weekday}@${slot.time}`, { weekday: slot.weekday, time: slot.time });
  }
  return [...unique.values()].sort((a, b) => a.weekday - b.weekday || a.time.localeCompare(b.time));
}

export const WEEKDAYS: readonly number[] = [1, 2, 3, 4, 5, 6, 7];
